import { ROUTES } from '@/common';

const useGetFraudReviewURL = () => {
  // Navigates to the Employees page. Flagged employees are ordered on top by the backend for
  // admins with the FRAUD_MONITORING_ALERT_VIEW permission (see EmployeesList).
  return ROUTES.EMPLOYEES;
};

export default useGetFraudReviewURL;
